import React from 'react';
import ReactMarkdown from 'react-markdown';
import {
  List,
  Datagrid,
  TextField,
  DateField,
  NumberField,

  TopToolbar,
  ExportButton,
  ChipField,
  FunctionField,
  Filter,
  SelectInput,
  SearchInput,
} from 'react-admin';

const updateTypeChoices = [
  { id: 'CHECKIN', name: '✅ Чекин' },
  { id: 'START', name: '🚀 Старт' },
  { id: 'COMPLETION', name: '🎉 Завершение' },
  { id: 'FAILURE', name: '❌ Провал' },
  { id: 'STATUS_CHANGE', name: '🔄 Изменение статуса' },
  { id: 'MILESTONE', name: '🏆 Веха' },
  { id: 'MOTIVATION', name: '💪 Мотивация' },
  { id: 'STRUGGLE', name: '😰 Борьба' },
  { id: 'SUCCESS', name: '🎯 Успех' },
];

const UpdateFilter = (props: any) => (
  <Filter {...props}>
    <SearchInput source="q" alwaysOn />
    <SelectInput
      source="type"
      choices={updateTypeChoices}
      label="Тип события"
    />
  </Filter>
);

const ListActions = () => (
  <TopToolbar>
    <ExportButton />
  </TopToolbar>
);

const TypeChip = ({ record }: any) => {
  if (!record || !record.type) return <span>-</span>;
  const updateType = updateTypeChoices.find(choice => choice.id === record.type);
  return <ChipField record={{ value: updateType?.name || record.type }} source="value" />;
};

const ContentPreview = ({ record }: any) => {
  if (!record?.content) return <span style={{ color: '#999' }}>Без текста</span>;
  const preview = record.content.length > 50 
    ? record.content.substring(0, 50) + '...' 
    : record.content;
  
  return (
    <div style={{ maxWidth: '200px', fontSize: '0.9em' }}>
      <ReactMarkdown
        components={{
          // Упрощенные стили для превью в таблице
          p: ({ children }) => <span>{children}</span>,
          strong: ({ children }) => <strong style={{ fontWeight: 600 }}>{children}</strong>,
          em: ({ children }) => <em style={{ fontStyle: 'italic' }}>{children}</em>,
          code: ({ children }) => (
            <code style={{ 
              background: '#f5f5f5', 
              padding: '1px 3px', 
              borderRadius: '3px',
              fontSize: '0.85em'
            }}>
              {children}
            </code>
          ),
          // Убираем переносы строк для компактности
          br: () => <span> </span>,
        }}
      >
        {preview}
      </ReactMarkdown>
    </div>
  );
};

export const ChallengeUpdateList = () => (
  <List
    filters={<UpdateFilter />}
    actions={<ListActions />}
    sort={{ field: 'createdAt', order: 'DESC' }}
    perPage={25}
  >
    <Datagrid>
      <TextField source="id" label="ID" />
      <FunctionField 
        label="Тип"
        render={(record: any) => <TypeChip record={record} />}
      />
      
      {/* Содержимое */}
      <FunctionField 
        label="Содержимое"
        render={(record: any) => <ContentPreview record={record} />}
      />
      
      {/* День челленджа */}
      <NumberField source="dayNumber" label="День" />
      
      {/* Автор события */}
      <TextField source="user.name" label="Автор" />
      <TextField source="user.email" label="Email автора" />
      
      {/* Челлендж */}
      <TextField source="challenge.title" label="Челлендж" />
      <TextField source="challenge.type" label="Тип челленджа" />
      <TextField source="challenge.status" label="Статус челленджа" />
      
      {/* Изображения */}
      <FunctionField 
        label="Фото" 
        render={(record: any) => 
          record.images?.length > 0 ? `📷 ${record.images.length}` : '-'
        } 
      />
      
      {/* Статистика */}
      <NumberField source="likesCount" label="❤️ Лайки" />
      <NumberField source="commentsCount" label="💬 Комментарии" />
      
      <DateField source="createdAt" label="Дата создания" showTime />
    </Datagrid>
  </List>
);
